import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

const IconTitle = props => {
    let { icon } = props;

    return <h1 className="main-term">{icon && icon.term}&nbsp;</h1>;
};

export default IconTitle;
